var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFilledTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.977,
    height: 5.002,
    viewBox: "0 0 7.977 5.002"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.319 3.142l2.88-2.82a1.13 1.13 0 011.58 0l2.88 2.82a1.09 1.09 0 01-.79 1.86h-5.76a1.09 1.09 0 01-.79-1.86z"
  })));
}
export default SvgArrowFilledTop;